import React from 'react';
import Header from './Header';
import Footer from './Footer/Footer';
import MainLayout from './MainLayout';
import { PageProps as GatsbyPageProps } from 'gatsby';
import * as styles from './Page.module.css';

type PageProps = {
  element: React.ReactNode;
  props: GatsbyPageProps;
};

const Page: React.FC<PageProps> = ({ element, props }) => {
  return (
    <>
      <Header />
      {/* Header分の高さを確保するためのdiv */}
      <div className={styles.space} />
      <MainLayout {...props}>{element}</MainLayout>
      <Footer location={props.location} />
    </>
  );
};

export default Page;
